import {
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_INVALID_DETAILS,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_LOCKED,
  FORGOT_PASSWORD_QUESTION,
  RESET_FORGOT_PASSWORD,
  LOADING_FORGOT_PASSWORD,
} from "../types";

const initialState = {
  isLoading: false,
  isLocked: false,
  failed: false,
  success: false,
  invalidDetails: false,
  question: false,
  networkError: "",
  data: "",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADING_FORGOT_PASSWORD:
      return {
        ...state,
        isLoading: true,
        isLocked: false,
        failed: false,
        success: false,
        invalidDetails: false,
        question: false,
        networkError: "",
        data: {},
      };

    case FORGOT_PASSWORD_LOCKED:
      return {
        ...state,
        isLoading: false,
        isLocked: true,
        failed: false,
        success: false,
        invalidDetails: false,
        question: false,
        networkError: "",
        data: payload,
      };
    case FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        failed: true,
        success: false,
        invalidDetails: false,
        question: false,
        networkError: "",
        data: payload,
      };
    case FORGOT_PASSWORD_INVALID_DETAILS:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        failed: false,
        success: false,
        question: false,
        invalidDetails: true,
        networkError: "",
        data: payload,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        failed: false,
        success: true,
        question: false,
        invalidDetails: false,
        networkError: "",
        data: payload,
      };
    case FORGOT_PASSWORD_QUESTION:
      return {
        ...state,
        isLoading: false,
        isLocked: false,
        failed: false,
        success: false,
        question: true,
        invalidDetails: false,
        networkError: "",
        data: payload,
      };

    case RESET_FORGOT_PASSWORD:
      return (state = initialState);

    default:
      return state;
  }
};
